var map = {
	"./AV.png": 40898,
	"./CAP.png": 20839,
	"./DLE.png": 90914,
	"./DTM.png": 77826,
	"./INP.png": 23832,
	"./MTTR.png": 80770,
	"./OEE.png": 80394,
	"./OUT.png": 25139,
	"./PE.png": 4882,
	"./PROD.png": 17880,
	"./QA.png": 82685,
	"./YLD.png": 98038,
	"./new/av.png": 90079,
	"./new/cap.png": 27284,
	"./new/cap2.png": 47612,
	"./new/dle.png": 51553,
	"./new/dtm.png": 4353,
	"./new/dtm1.png": 26700,
	"./new/mtbf.png": 31009,
	"./new/mttr.png": 70855,
	"./new/oee.png": 99305,
	"./new/pe.png": 32147,
	"./new/prod.png": 80449,
	"./new/prodn.png": 49259,
	"./new/prodn1.png": 95322,
	"./new/qa.png": 13120,
	"./new/yld.png": 69117,
	"./old/AV.png": 99628,
	"./old/DLE.png": 66356,
	"./old/DT.png": 36181,
	"./old/OEE.png": 58464,
	"./old/OLE.png": 47143,
	"./old/PE.png": 66968,
	"./old/PROD.png": 28230,
	"./old/QA.png": 69859,
	"./old1/AV.png": 42529,
	"./old1/DLE.png": 55083,
	"./old1/DT.png": 42708,
	"./old1/OEE.png": 71807,
	"./old1/OLE.png": 32296,
	"./old1/PE.png": 87313,
	"./old1/PROD.png": 63159,
	"./old1/QA.png": 30830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10255;